export function TOS() {
  return (
    <div className="space-y-4 text-sm text-foreground">
      <h1 className="text-2xl font-bold">Terms of Service</h1>
      <p>
        <strong>Effective Date:</strong> December 1, 2024
      </p>

      <p>
        Welcome to Hoops Finance! By using our OAuth login with Google, you agree to the following Terms
        and Conditions (&quot;Terms&quot;). Please read them carefully before accessing or using the
        Service.
      </p>

      <h2 className="font-semibold mt-4">1. Acceptance of Terms</h2>
      <p>
        By accessing or using the Hoops Finance OAuth login with Google (&quot;Service&quot;), you agree
        to be bound by these Terms. If you do not agree to all the terms and conditions, then you may not
        access the Service.
      </p>

      <h2 className="font-semibold mt-4">2. Use of Data</h2>
      <h3 className="font-medium mt-2">2.1 Data Collected</h3>
      <p>
        When you use the Service, we may access certain personal information from your Google account, as
        authorized by you. This information may include:
      </p>
      <ul className="list-disc ml-6">
        <li>Your name</li>
        <li>Email address</li>
        <li>Profile picture</li>
        <li>Basic profile information</li>
      </ul>

      <h3 className="font-medium mt-2">2.2 Purpose of Data Use</h3>
      <p>We use the data collected solely for the following purposes:</p>
      <ul className="list-disc ml-6">
        <li>
          <strong>Providing and Improving the Service:</strong> To authenticate your identity,
          personalize your experience, and enhance our services.
        </li>
        <li>
          <strong>Communication:</strong> To contact you with updates, newsletters, or information
          related to your account or transactions.
        </li>
      </ul>

      <h3 className="font-medium mt-2">2.3 Data Privacy</h3>
      <ul className="list-disc ml-6">
        <li>
          <strong>Confidentiality:</strong> We are committed to protecting your privacy. We do not sell,
          rent, or share your personal information with third parties, except as necessary to provide the
          Service or as required by law.
        </li>
        <li>
          <strong>Third-Party Service Providers:</strong> We may employ trusted third-party companies and
          individuals to facilitate our Service, perform Service-related services, or assist us in
          analyzing how our Service is used. These third parties have access to your personal information
          only to perform these tasks on our behalf and are obligated not to disclose or use it for any
          other purpose.
        </li>
      </ul>

      <h3 className="font-medium mt-2">2.4 Data Security</h3>
      <p>
        We implement commercially reasonable security measures to protect your personal information from
        unauthorized access, alteration, disclosure, or destruction. However, no method of transmission
        over the Internet or electronic storage is 100% secure.
      </p>

      <h2 className="font-semibold mt-4">3. User Responsibilities</h2>
      <h3 className="font-medium mt-2">3.1 Account Security</h3>
      <p>
        You are responsible for maintaining the confidentiality of your account credentials and for
        restricting access to your device. You agree to accept responsibility for all activities that
        occur under your account.
      </p>

      <h3 className="font-medium mt-2">3.2 Accurate Information</h3>
      <p>
        You agree to provide accurate, current, and complete information and to update it as necessary.
        Hoops Finance has the right to suspend or terminate your account and refuse any and all current
        or future use of the Service if you provide any information that is untrue, inaccurate, or
        incomplete.
      </p>

      <h2 className="font-semibold mt-4">4. Intellectual Property Rights</h2>
      <p>
        All content, features, and functionality on the Service—including but not limited to text,
        graphics, logos, and software—are the exclusive property of Hoops Finance and are protected by
        international copyright, trademark, patent, trade secret, and other intellectual property or
        proprietary rights laws.
      </p>

      <h2 className="font-semibold mt-4">5. Disclaimer of Warranties</h2>
      <p>
        The Service is provided on an &quot;as-is&quot; and &quot;as-available&quot; basis. Hoops Finance
        makes no representations or warranties of any kind, express or implied, regarding the use or the
        results of the Service in terms of its correctness, accuracy, reliability, or otherwise. Your use
        of the Service is at your sole risk.
      </p>

      <h2 className="font-semibold mt-4">6. Limitation of Liability</h2>
      <p>
        In no event shall Hoops Finance, its affiliates, or their respective officers, directors,
        employees, or agents be liable for any indirect, incidental, special, consequential, or punitive
        damages arising out of or related to your use of the Service, even if advised of the possibility
        of such damages. Hoops Finance&apos;s total liability to you for any damages, losses, or causes
        of action shall not exceed the amount paid by you, if any, for accessing the Service.
      </p>

      <h2 className="font-semibold mt-4">7. Indemnification</h2>
      <p>
        You agree to indemnify, defend, and hold harmless Hoops Finance, its affiliates, and their
        respective officers, directors, employees, and agents from and against any and all claims,
        liabilities, damages, losses, or expenses—including reasonable attorneys&apos; fees and
        costs—arising out of or in any way connected with your access to or use of the Service or
        violation of these Terms.
      </p>

      <h2 className="font-semibold mt-4">8. Changes to Terms</h2>
      <p>
        Hoops Finance reserves the right, at its sole discretion, to modify or replace these Terms at any
        time. If a revision is material, we will attempt to give at least 30 days&apos; notice via email
        or through the Service before any new terms take effect, however at all times using the service
        constitutes acceptance of the terms. What constitutes a material change will be determined at our
        sole discretion. Your continued use of the Service after any changes to the Terms constitutes
        acceptance of those changes.
      </p>

      <h2 className="font-semibold mt-4">9. Termination</h2>
      <p>
        We may terminate or suspend your access to the Service immediately, without prior notice or
        liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon
        termination, your right to use the Service will cease immediately.
      </p>

      <h2 className="font-semibold mt-4">10. Governing Law</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the laws of the State of
        Delaware, United States, without regard to its conflict of law provisions. You agree to submit to
        the personal and exclusive jurisdiction of the courts located within the State of Delaware.
      </p>

      <h2 className="font-semibold mt-4">11. Severability</h2>
      <p>
        If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining
        provisions of these Terms will remain in effect.
      </p>

      <h2 className="font-semibold mt-4">12. Waiver</h2>
      <p>
        No waiver by Hoops Finance of any term or condition set forth in these Terms shall be deemed a
        further or continuing waiver of such term or condition or a waiver of any other term or
        condition.
      </p>

      <h2 className="font-semibold mt-4">13. Entire Agreement</h2>
      <p>
        These Terms constitute the entire agreement between you and Hoops Finance regarding the Service
        and supersede and replace any prior agreements we might have had between us regarding the
        Service.
      </p>

      <h2 className="font-semibold mt-4">14. Contact Information</h2>
      <p>If you have any questions about these Terms, please contact us at:</p>
      <p>
        <strong>Email:</strong>{" "}
        <a href="mailto:support@hoops.finance" className="underline text-primary">
          support@hoops.finance
        </a>
      </p>
    </div>
  );
}
